import { render } from "./MakeStake.vue?vue&type=template&id=72c65de6&scoped=true"
import script from "./MakeStake.vue?vue&type=script&lang=js"
export * from "./MakeStake.vue?vue&type=script&lang=js"

import "./MakeStake.vue?vue&type=style&index=0&id=72c65de6&scoped=true&lang=css"
import "./MakeStake.vue?vue&type=style&index=1&id=72c65de6&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c65de6"]])

export default __exports__